import { makeStyles } from '@material-ui/core';

const h2m = {
  fontWeight: '600',
  fontSize: '25px',
  lineHeight: '140%',
};

const h3m = {
  fontWeight: 600,
  fontSize: '18px',
  lineHeight: '25.2px',
};

export const variant = {
  h1: {
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '50px',
    lineHeight: '65px',
    '@media (max-width: 1366px)': {
      fontWeight: 'bold',
      fontSize: '30px',
      lineHeight: '28px',
    },
  },
  h2: {
    fontWeight: 600,
    fontSize: '35px',
    lineHeight: '45px',
    '@media (max-width:768px)': {
      ...h2m,
    },
  },
  h2m,
  h3: {
    fontWeight: 'bold',
    fontSize: '25px',
    lineHeight: '32px',
    '@media (max-width:768px)': {
      ...h3m,
    },
  },
  h3m,
  h4: {
    fontSize: '20px',
    lineHeight: '28px',
    fontWeight: 500,
  },
  text: {
    fontWeight: 'normal',
    fontSize: '16px',
    lineHeight: '140%',
  },
  smallText: {
    fontStyle: 'normal',
    fontSize: '14px',
    lineHeight: '140%',
  },
  textMedium: {
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '16px',
    lineHeight: '140%',
  },
  caption: {
    fontSize: '14px',
    lineHeight: '19.6px',
  },
  tag: {
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '18px',
  },
};

export const useTypographyVariants = makeStyles(variant);
